import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  buzz: {
    channels: {},
    chats: {},
  },
  productivity: [],
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.NOTIFICATION_SETTINGS__LOADED_BUZZ_SETTINGS:
      return {
        ...state,
        buzz: action.payload,
      };

    case AppConstants.NOTIFICATION_SETTINGS__BUZZ_SETTINGS_UPDATED: {
      return {
        ...state,
        buzz: action.payload,
      };
    }

    case AppConstants.NOTIFICATION_SETTINGS__LOADED_PRODUCTIVITY_SETTINGS: {
      return {
        ...state,
        productivity: action.payload,
      };
    }

    case AppConstants.NOTIFICATION_SETTINGS__PRODUCTIVITY_SETTINGS_UPDATED: {
      return {
        ...state,
        productivity: action.payload,
      };
    }

    default:
      return state;
  }
};
